/* Use {id, no, name} on fn_setSelOpt for customData Nov 11, 2023 */
/* Add transform up-9  Nov 24, 2023 */
/* Add email for Contact Sep 21, 2024 */
/* Add required Feb 1, 2025 */
/* Add Noborders,p_class May 10, 2025 */
<template lang="pug">
	div(class="kt-select")
		b-input-group-prepend
			b-input-group-text(v-if="!p_noIcon" @click="m_viewModal" :disabled="c_isEmpty"
				v-b-tooltip.hover.auto.ds500="{title: 'View ' + c_appEntName}")
				img(v-if="d_appEnt.key=='team' && d_selOpt.profPic" :src="m_profPicURL(d_selOpt.recId)")
				fa-icon(v-else :icon="d_appEnt.key=='team' ? 'user' : d_appEnt.icon" :color="d_appEnt.color")
				
			div(class="sel-cont" )
				div(id="mainInput" ref="input" class="input" :class="p_class"  :disabled="p_readOnly" :invalid="c_isInvalid" :open="d_optOpen" @click.stop="m_onClickInput"
					:title="c_isEmpty?null:d_selOpt.recName + (d_selOpt.recDesc? ' ('+d_selOpt.recDesc+')':'')" )
					//- img(v-if="d_appEnt.key=='team' && !c_isEmpty" :key="d_selOpt.recId" :src="m_profPicURL(d_selOpt.recId)")
					div(class="num-link" v-if="!p_searcher && d_usrOpt.showRecordNumbers" v-show="!d_optOpen && !c_isEmpty && !c_isInvalid")
						span(@click.stop="m_viewModal" ) {{d_selOpt.recNo}}
						span -
					div(class="input-text" :contenteditable="!p_readOnly" :data-placeholder="c_placeholder"
						@focusout.stop="m_onFocusout" @input="m_onInput" @keydown.enter.prevent) 
					div(class="rec-desc" v-if="!p_searcher && d_selOpt.recDesc" v-show="!d_optOpen && !c_isEmpty && !c_isInvalid") ({{d_selOpt.recDesc}})
				b-button(class="btn-clear" v-if="!p_readOnly" v-show="d_inputVal||!c_isEmpty" variant="none" title="Clear" @click="m_onClickClear")
					fa-icon(icon="times")
				b-button(class="btn-caret" v-if="!p_readOnly && !p_searcher" v-show="!d_inputVal&&c_isEmpty" variant="none" @click="m_onClickCaret")
					fa-icon(:icon="d_optOpen? 'caret-up':'caret-down'")
				fa-icon(v-if="p_searcher" v-show="!d_inputVal" icon="search")
				
				//- Options
				div(class="options-container" v-if="!p_readOnly" v-show="d_optOpen" @mousedown="d_keepOpen=true" @mouseup="m_reFocus")
					div(class="info")
						span(v-if="d_loading")
							div(class="spinner-border spinner-border-sm" role="status") 
							span Loading...
						span(v-else-if="d_optSrch")
							fa-icon(icon="search")
							span {{d_optSrch.length>0 ? 'Search Results...' : 'No Results Found'}}
						span(v-else-if="(p_dfltOpts||[]).length")
							span {{p_dfltOptsLbl || 'Default Options'}} ...
						span(v-else)
							fa-icon(icon="history")
							span {{d_optInit.length>0 ? 'Recently Searched, Updated or Created...' : 'No Data Found'}}
					
					div(class="grouped" v-if="c_groupedOpt" v-for="(grp,gix) in c_groupedOpt" :key="gix")
						div(class="rec-type")
							fa-icon(:icon="grp.icon" :color="grp.color")
							| {{grp.label}}
						div(v-for="(o,oix) in grp.opts" :key="oix" class="opt" @mouseup="m_onClickOpt(o)")
							div
								span(class="rec-no" v-if="d_usrOpt.showRecordNumbers") {{o.recNo}} - 
								span(class="rec-name") {{o.recName}}
								span(class="rec-desc" v-if="o.recDesc") ({{o.recDesc}})
					div(class="opt" v-if="!c_groupedOpt" v-for="(o,ix) in (d_optSrch||d_optInit)" :key="ix"
						:class="m_isSelected(o)? 'sel': null" @mouseup.stop="m_onClickOpt(o)")
						img(v-if="d_appEnt.key=='team'" class="small-round-profile" :src="m_profPicURL(o.profPic?o.recId:0)")
						div
							span(class="rec-no" v-if="d_usrOpt.showRecordNumbers") {{o.recNo}} - 
							span(class="rec-name") {{o.recName}}
							span(class="rec-desc" v-if="o.recDesc") ({{o.recDesc}})
						
			b-button(v-if="!p_readOnly && p_enableCreate" variant="none" class="btn-add-new" style="margin-left:-0.2em;margin-right:-0.2em;"
				v-b-tooltip.hover.auto.ds500="{title: 'Create a New ' + c_appEntName}" @click="m_createNew_Modal()")
				fa-icon(icon="folder-plus" transform="up-9 left-1")
</template>

<script>
import { fn_simpleSearch } from "@/utils/api.js";
import { fn_appEnt, userSettings } from "@/utils/ref-data.js";
import {
  fn_humanizeLabel,
  fn_hrefVwRec,
  kbdpAlert,
  kbdpRecord,
  fn_profilePicURL,
} from "@/utils/util.js";
export default {
  name: "kt-select",
  components: {},
  created() {
    fn_setSelOpt(this, this.p_currentVal); //Need to do this for non-promise initial value
  },
  mounted() {
	console.log("d_appEnt");
	console.log(this.d_appEnt);
    fn_inputTxtHelper(this, 1);
	var rw;
	
	if(this.$el) rw = this.$el.closest(".rec-wrap");

    if (rw) {
      this.d_recWrapVC = rw.__vue__;
    }
	
  },
  data() {
    return {
      d_appEnt: fn_appEnt(this.p_appEntKey),
      d_inputVal: null,
      d_optOpen: null,
      d_optInit: [], //Initial Options (On initial click --> m_onClickInput)
      d_optSrch: null, //Search Result Options (On every search --> m_onInput)
      d_selOpt: {}, //SelectedOpt
      d_keepOpen: null,
      d_loading: null,
      d_recWrapVC: null, //Set when mounted

      d_usrOpt: userSettings.userOptions,
    };
  },
  props: {
    p_appEntKey: {type: String, required: true },
    p_currentVal: Object,
    p_readOnly: {type: Boolean, default: false },
    p_enableCreate: {type: Boolean, default: false },
    p_required: {type: Boolean, default: false },
    p_dfltOpts: Array,
    p_dfltOptsLbl: String,
    p_filterKey: String,
    p_filterFirstKey: [String, Number],
    p_noIcon: {type: Boolean, default: false },
    p_placeholder: {type: String, default: null },
    p_searcher: {type: Boolean, default: false },
    p_class: {type: String, default: "" },
  },
  computed: {
    c_appEntName() {
      return fn_humanizeLabel(this.d_appEnt.name);
    },
    c_placeholder() {
      if (this.p_readOnly)
        return this.p_placeholder || "No " + this.c_appEntName + " Selected";
      else return this.p_placeholder || "Search " + this.d_appEnt.label;
    },
    c_isEmpty() {
      return (this.d_selOpt.recId || null) == null;
    },
    c_isInvalid() {
      if (this.p_searcher || this.p_readOnly) return false;
      if (this.p_required && this.c_isEmpty) return true;

      if (this.d_inputVal) {
        if (this.c_isEmpty) return true;
      }

      return false;
    },
    c_selOptHref() {
      if (this.c_isEmpty) return null;
      let appEntKey = this.d_selOpt.recType || this.d_appEnt.key;
      let recNo = this.d_selOpt.recNo;
      return fn_hrefVwRec(appEntKey, recNo);
    },
    c_groupedOpt() {
      if (this.d_appEnt.key != "all") return null;

      let opts = this.d_optSrch || this.d_optInit;
      let grps = opts
        .map((x) => x.recType)
        .filter((x, i, a) => a.indexOf(x) == i); //Distinct,Unique

      return grps.map((grp) => {
        let ae = fn_appEnt(grp);
        return {
          label: ae.label,
          icon: ae.icon,
          color: ae.color,
          opts: opts.filter((opt) => opt.recType == grp),
        };
      });
    },
	c_class() {return this.p_class;},
  },
  methods: {
    m_onClickInput() {
      if (this.p_readOnly) return;
      if (this.p_searcher && !this.d_optSrch) return;
      this.d_optOpen = true;
      fn_inputTxtHelper(this, 0, 1); //Focus

      // if (this.d_optInit.length > 0) return;

      let dfltOpt = this.p_dfltOpts || [];
      if (dfltOpt.length) {
        let ae = this.d_appEnt;
        dfltOpt.forEach((dOpt) => {
          //Push unique only
          let exists = this.d_optInit.filter(
            (x) => x.recId == dOpt[ae.idKey]
          )[0];
          if (!exists) {
            this.d_optInit.push({
              recId: dOpt[ae.idKey],
              recNo: dOpt[ae.numKey],
              recName: dOpt[ae.nameKey],
            });
          }
        });
        return;
      }

      let params = {
        context: this.d_appEnt.name,
        filter: this.p_filterKey,
        filterFirst: this.p_filterFirstKey,
      };
      this.d_loading = true;
      let _this = this;
      fn_simpleSearch(params).then((resp) => {
        _this.d_optInit = resp.searchResult || [];
        _this.d_loading = null;
      });
    },
    m_onFocusout(e) {
      if (this.p_readOnly) return;
      this.timeout = setTimeout(() => {
        //Close Opts List, keep open if clear btn is clicked (wait 200ms)
        this.d_optOpen = this.d_keepOpen;
        this.d_keepOpen = null;
      }, 200);

      if (this.d_inputVal) this.d_selOpt = {};
    },

    m_onInput(e) {
      let _this = this;
      let tc = e.target.textContent;
      // e.target.textContent.replace(/\r?\n|\r/g, ''); //Not quite right? Causing issues in FF.
      //Remove CRLFs on Copy/Pasta and Trim
      _this.d_inputVal = tc.trim();

      if (_this.timeout) clearTimeout(_this.timeout);
      _this.timeout = setTimeout(() => {
        if (!_this.d_inputVal) {
          // fn_clear(_this);
          this.m_onClickClear();
          return;
        }

        let params = {
          context: _this.d_appEnt.name,
          query: _this.d_inputVal,
          filter: _this.p_filterKey,
        };
        _this.d_loading = true;
        fn_simpleSearch(params).then((resp) => {
          _this.d_optSrch = resp.searchResult || [];
          _this.d_loading = null;

          if (_this.p_searcher) _this.d_optOpen = true;
        });
      }, 500);
    },

    m_onClickOpt(opt) {
      this.d_selOpt = opt;
      if (!this.p_searcher) {
        this.d_optOpen = this.d_keepOpen = null;
        this.d_inputVal = null;
        fn_inputTxtHelper(this, 1);
        fn_emitChange(this);
      } else {
        let href = this.c_selOptHref;
        if (this.$route.hash != href) this.$router.push({ path: href });
        this.timeout = setTimeout(() => {
          this.d_keepOpen = null;
        }, 201);
      }
    },
    m_onClickClear() {
      fn_clear(this);
      if (!this.p_searcher) {
        fn_emitChange(this);
        this.d_keepOpen = this.d_optOpen;
        if (this.d_optOpen) {
          fn_inputTxtHelper(this, 0, 1); //Focus
        }
      }
    },
    m_onClickCaret() {
      if (this.d_optOpen) this.d_optOpen = this.d_keepOpen = null;
      else this.m_onClickInput();
    },

    m_reFocus() {
      if (this.p_readOnly) return;
      fn_inputTxtHelper(this, 0, 1); //Focus
    },

    m_isSelected(opt) {
      return (
        opt.recId == this.d_selOpt.recId && opt.recType == this.d_selOpt.recType
      );
    },
    m_optRecType(opt) {
      return fn_humanizeLabel(fn_appEnt(opt.recType).name);
    },

    m_viewModal(e) {
      let recNo = this.d_selOpt.recNo;
      if (!recNo) return;

      let rw = this.d_recWrapVC;
      if (rw && rw.d_bmId) {
        rw.d_modal.appEntKey = this.p_appEntKey;
        rw.d_modal.recNo = recNo;
        this.$bvModal.show(rw.d_bmId);
      } else if (rw) {
        window.open(this.c_selOptHref, "_blank");
      } else {
        kbdpRecord.showRecord(this.p_appEntKey, recNo);
      }
    },
    m_createNew_Modal() {
		console.log("In m_createNew_Modal");
      let rw = this.d_recWrapVC;
      if (!rw) return;
      rw.d_modal.appEntKey = this.p_appEntKey;
      rw.d_modal.createNew = this.p_enableCreate;
      rw.d_modal.saveNewFn = this.m_saveNew_Modal;
	  console.log(rw);
      this.$bvModal.show(rw.d_bmId);
    },
    m_saveNew_Modal() {
      let _this = this;
      let rw = _this.d_recWrapVC;
      if (!rw) return;
      rw.$refs["rec-create-new"].m_saveFn().then((resp) => {
        if (!resp.newRecHdr) {
          let msg =
            "Unable to create " + _this.c_appEntName + ". " + resp.errorMessage;
          kbdpAlert.showErr(msg);
          return;
        }
        fn_setSelOpt(_this, resp.newRecHdr);
        fn_emitChange(_this);
        _this.$bvModal.hide(rw.d_bmId);

        let msg = _this.d_selOpt.recName + " is Created Successfully.";
        kbdpAlert.showOk(msg);
      });
    },

    m_profPicURL(tmId) {
      return fn_profilePicURL(tmId);
    },

    //Called Externally
    m_clearSelOpt() {
      fn_clear(this);
    },
  },
  watch: {
    p_currentVal(val, ov) {
      console.log("p_currentVal");
      console.log(this.p_currentVal);
      fn_setSelOpt(this, val); //For setting initial value after promise load from parent
      fn_inputTxtHelper(this, 1);
    },
    p_readOnly(nv, ov) {
      if (nv) {
        this.d_inputVal = null; //Need to do this to clear input val when edit=> cancel on records
        fn_inputTxtHelper(this, 1);
      }
    },
  },
};

function fn_clear(vc) {
  vc.d_optSrch = vc.d_inputVal = null;
  vc.d_selOpt = {};
  fn_inputTxtHelper(vc, 1);
}
function fn_emitChange(vc) {
  let ae = vc.d_appEnt;
  let so = vc.d_selOpt;
  let val = !so.recId
    ? {}
    : {
        [ae.idKey]: so.recId,
        [ae.numKey]: so.recNo,
        [ae.nameKey]: so.recName,
      };

  ["appUserId", "profPic", "recDesc", "email"].forEach((k) => {
    if (so[k]) val[k] = so[k];
  });
  vc.$emit("change", val);
}
function fn_setSelOpt(vc, val) {
  fn_clear(vc);
  if (!Object.keys(val || {}).length) return;
  let ae = vc.d_appEnt;
  vc.d_selOpt = {
    recId: val[ae.idKey]||val["id"],
    recNo: val[ae.numKey]||val["no"],
    recName: val[ae.nameKey]||val["name"],
  };
  ["appUserId", "profPic", "recDesc","email"].forEach((k) => {
    if (val[k]) vc.d_selOpt[k] = val[k];
  });
  vc.d_inputVal = null;
}
function fn_inputTxtHelper(vc, setTxt, focus) {
  let inpt = vc.$refs["input"];
  if (!inpt) return;

  let inptTxt = inpt.getElementsByClassName("input-text")[0];
  // console.log(setTxt, vc.c_selOptLabel);
  if (setTxt) {
    inptTxt.textContent = vc.d_selOpt.recName;
  }
  if (focus) {
    $(inptTxt).trigger("focus");
    document.execCommand("selectAll", false, null);
    document.getSelection().collapseToEnd();
  }
}
</script>

<style lang="less">
.kt-select {
  .input-group-text {
    font-size: 0.8em;

    color: #6c757d;
    justify-content: center;
    padding: 0em 0.75em;
    width: 25px;

    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-right: none;

    &[disabled] {
      pointer-events: none;
    }

    &:hover {
      cursor: pointer;
      background-color: #dee2e6;
    }

    & ~ .sel-cont div.input {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }

    > img {
      border-radius: 0.75em;
      height: 22px;
      margin: auto 0;
      // display: none;
    }
  }
  .sel-cont {
    position: relative;
    width: 100%;

    div.input {
      padding: 0.155em 0.2em;
      padding-right: 1.5em;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      border-radius: 0.25rem;
      border-bottom: 1px solid #ced4da;
      > div {
        display: inline;
        font-size: 0.9rem;
        line-height: 1.5em;
      }
      div.num-link {
        span:first-child {
          color: #4fa4ff;
          font-size: 0.9em;
          padding: 0 0.25em;
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
        }
      }
      div.input-text {
        cursor: text;
        padding: 0.1em 0.25em;
        &:focus {
          outline: none;
          // outline: solid 0.2em blue;
        }
        &:empty:before {
          content: attr(data-placeholder);
          opacity: 0.6;
        }
      }
      div.rec-desc {
        cursor: text;
        font-size: 0.9em;
        color: #adb5bd;
        // -webkit-user-select: none;
        // outline: solid 0.1em blue;
      }
    }
    div.input.styled-input {
      border: 0px;
      border-radius: 0px;
      border-bottom: 1px solid #000000;
    }

    .btn-clear,
    .btn-caret,
    > svg[data-icon="search"] {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 0.4em;
      font-size: 0.8em;
      opacity: 0.4;
      &.btn-clear {
        background-color: #e9ecef;
        &:hover {
          opacity: unset;
        }
      }
    }
    div.input[disabled="disabled"] {
      //background-color: #e9ecef;
      padding-right: 0.5em;
	border-bottom: 1px solid #ddd;
    }
    div.input.styled-input[disabled="disabled"] {
      background-color: transparent;
      padding-right: 0.5em;
      border-bottom: 1px solid #ddd;
    }
    div.input:not([open])[invalid] {
      //border-color: #dc3545;
      box-shadow: none;
      color: #dc3545;
    }
    div.input[open="open"] {
      //border-color: #cfe6ff;
	  borders:none;
      outline: 0;
      box-shadow: 0 0 0 0.1rem #4fa4ff40;
      > div.input-text {
        display: -webkit-box;
      }
    }

    div.input,
		// div.input[open="open"] div.input-text,
		div.options-container div.opt > div {
      ///***
      margin: auto 0;
      -ms-word-break: break-all;
      word-break: break-all;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1; /* number of lines to show */
      -webkit-box-orient: vertical;
	  borders:none;
    }
    div.options-container {
      position: absolute;
      width: 100%;
      min-height: 2em;
      max-height: 300px;
      overflow-y: auto;
      margin-top: 0.1em;
      border: solid 0.1em #ced4da;
      box-shadow: 0 0 0 0.05rem #ced4da;
      border-top: none;
      background-color: #ffffff;
      z-index: 1051;
      padding-bottom: 0.5em;
      div.info {
        font-size: 0.8em;
        // padding: 0.3em 0.5em;
        padding: 0.5em 0.5em;
        // padding-left: 0.75em;

        > span {
          display: flex;
          align-items: center;
          > div.spinner-border,
          > svg {
            margin: auto 0.75em;
            color: #4fa4ff;
          }
          > span {
            color: #adb5bd;
          }
        }
      }
      div.grouped {
        margin-bottom: 0.5em;
        div.rec-type {
          border-bottom: solid 0.1em #adb5bd;
          background-color: #e9ecef;
          font-size: 0.9em;
          font-weight: bolder;
          > svg {
            margin: 0 0.5em;
          }
        }
        div.opt {
          color: #4fa4ff;
          // white-space: nowrap;
          // overflow: hidden;
          // text-overflow: ellipsis;
          &:hover {
            text-decoration: underline;
          }
        }
      }

      div.opt {
        padding: 0 0.5em;
        cursor: pointer;
        border-bottom: solid 0.1em #ced4da;
        display: flex;
        // min-height: 30px;
        > img {
          border-radius: 1em;
          margin: auto 0;
          margin-right: 0.5em;
        }
        > div {
          font-size: 0.9em;
          line-height: 1.1em;
          padding: 0.4em 0;
          ///***
          -webkit-line-clamp: 2 !important; /* number of lines to show */

          .rec-no {
            color: #4fa4ff;
            font-size: 0.9em;
          }
          .rec-desc {
            font-size: 0.9em;
            padding-left: 0.3em;
            color: #adb5bd;
          }
        }

        &.rec-type {
          font-size: 0.8em;
          margin-left: 0.5em;
          color: #4fa4ff;
        }
        &:hover {
          background-color: #f8f9fa;
        }
      }
      div.opt.sel {
        background-color: #e9ecef;
        .rec-no,
        .rec-name {
          font-weight: bolder;
        }
      }
    }
  }
  .btn-add-new {
    padding: 0 0.25em;
    margin: auto 0.25em;
    color: #4fa4ff;
    &:hover {
      background-color: #dee2e6;
    }
  }
}

.btn:focus {
  outline: none;
  box-shadow: none;
}
.small-round-profile {
  width: 20px;
  height: 20px;
  border-radius: 50%;
}
.Noborders{
	border-radius: 0.0rem !important;
	border:none !important;
}
.styled-input,
.styled-select {
  width: 100%;
  border: 0px;
  border-radius: 0px;
  border-bottom: 1px solid #ddd;  //1px solid black;
}
.styled-input:disabled,
.styled-select:disabled {
  background-color: transparent;
  border-bottom: 1px solid #ddd;
}
.styled-input:focus,
.styled-select:focus {
  border-color: transparent;
  border-bottom: 1px solid #428bca;    //1px solid #428bca;
  box-shadow: none;
}
.input-text {
  display: block;          /* stops inline auto-resizing */
  width: 40ch;             /* fixed width for ~40 characters */
  max-width: 100%;         /* prevents overflow */
  box-sizing: border-box;  /* keeps padding inside width */
  overflow: hidden;        /* prevents content pushing width */
  white-space: nowrap;     /* keeps text on one line */
}
.kt-select .options-container {
  z-index: 9999;
}
.kt-create-staffing{
    max-height: 200px !important;
    border-radius: 0.0rem !important;
	border:none !important;
}
</style>
